"use client";
import { useEffect } from 'react';

interface FontPreloaderProps {
  fontFamilies: string[];
}

/**
 * Preloads only essential font variants to reduce network requests
 * Only loads Regular and Bold variants, skips Italic for dashboard previews
 */
export const FontPreloader: React.FC<FontPreloaderProps> = ({ fontFamilies }) => {
  useEffect(() => {
    const preloadedFonts = new Set<string>();
    
    fontFamilies.forEach(fontFamily => {
      // Only preload Regular and Bold variants for dashboard previews
      const variants = ['Regular', 'Bold'];
      
      variants.forEach(variant => {
        const fontUrl = `/fonts/${fontFamily}-${variant}.ttf`;
        
        if (!preloadedFonts.has(fontUrl)) {
          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'font';
          link.type = 'font/ttf';
          link.href = fontUrl;
          link.crossOrigin = 'anonymous';
          
          document.head.appendChild(link);
          preloadedFonts.add(fontUrl);
        }
      });
    });
    
    return () => {
      // Cleanup if needed
    };
  }, [fontFamilies]);

  return null;
};

/**
 * Hook to get unique font families from all resumes
 */
export const useUniqueFontFamilies = (resumes: Array<{ settings: { fontFamily: string } }>) => {
  return Array.from(new Set(resumes.map(r => r.settings.fontFamily)));
};